export const starbucksFranchises = [
  'STARBUCKS UK',
  'STARBUCKS ITALY',
  'STARBUCKS SWITZERLAND',
  'STARBUCKS AUSTRIA',
];
export const alseaLACFranchises = [
  'Alsea Mexico',
  'Alsea Chile',
  'Alsea Colombia',
];
export const neukFranchises = [
  'CAFE FORTUNE LIMITED',
  'CREMA LTD',
  'WELCOME BREAK GROUP',
  'NEC LTD',
  'EGSPRESSO LTD',
  'KBEVERAGE LTD',
  'OCO WEST END LIMITED',
  'SOUL COFFEE HOUSE LTD',
  '1 OAK LTD',
  'KASTIEN COFFEE LTD',
  'THE MAGIC BEAN CO LTD',
  'AMSRIC LTD',
  'SIXTEEN88 LTD',
  'ARABICA COFFEE LTD',
  '23.5 DEGREES',
  'ELITE COFFEE LTD',
  'COBRA COFFEE LTD',
  'QUEENSWAY COFFEE HOUSES LTD',
  'EG ON THE MOVE LTD',
  'BURTON & SPEKE LIMITED',
  'AMSRIC LTD',
];
export const amrestFranchises = [
  'AMREST',
  'AmRest Bulgaria',
  'AmRest Czechia',
  'AmRest Poland',
  'AmRest Romania',
  'AmRest Slovakia',
];
export const amrestQSLODSFranchises = [
  'AmRest Poland',
  'AmRest Hungary',
];